export default __webpack_public_path__ + "static/media/breastfeeding-full.c48d3bc8.png";